export default __webpack_public_path__ + "static/media/uk.af49ad09.jpg";